import { planTypes } from '@/common/constants';
import { getPlanLogo } from '@/common/plan-logo-map';

export default {
  data() {
    return {
      title: this.$t('billing.video_sdk_uc.free_trial_title'),
      subtitle: '',
      logo: getPlanLogo(planTypes.VIDEO_SDK_UC),
      trackingPlanName: this.$t('billing.video_sdk_uc.free_trial_title'),
      planType: planTypes.VIDEO_SDK_UC,
    };
  },
};
